<template>
  <div>
    <v-text-field
      :label="$t('components.formOpen.fields.label.name')"
      v-model="question.label"
      :error-messages="labelErrors"
      color="valid"
    />
    <v-textarea
      name="text"
      :label="$t('components.formOpen.fields.text.name')"
      v-model="question.text"
      :error-messages="textErrors"
      color="valid"
    />
    <v-radio-group v-model="question.isLong"
                   :label="$t('components.formOpen.fields.isLong[0].name')"
                   :column="true"
    >
      <v-radio
        v-for="(size, index) in sizes"
        :key="index"
        :label="size.text"
        :value="size.value"
        color="valid"
      />
    </v-radio-group>
    <div class="tooltip">
      <v-switch
        :label="$t('components.formOpen.fields.required.name')"
        v-model="question.required"
        color="valid"
      />
      <v-tooltip right content-class="app__tooltip__ernest">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="app__tooltip__cursor__ernest">info</v-icon>
        </template>
        <span>{{ $t('components.formOpen.fields.required.tooltip') }}</span>
      </v-tooltip>
    </div>
    <div class="tooltip">
      <v-switch
        :label="$t('components.formOpen.fields.isActive.name')"
        v-model="question.isActive"
        color="valid"
      />
      <v-tooltip right content-class="app__tooltip__ernest">
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="app__tooltip__cursor__ernest">info</v-icon>
        </template>
        <span>{{ $t('components.formOpen.fields.isActive.tooltip')}}</span>
      </v-tooltip>
    </div>
    <save-buttons
      @save="save"
      :is-modification="isModification"
      :just-save="justSave"
    ></save-buttons>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { mapActions, mapGetters } from 'vuex'
import saveButtons from '@/components/questions/saveButtons'

const questionType = 'open'

export default {
  name: 'formOpen',
  components: {
    saveButtons
  },
  props: {
    isClone: {
      required: false,
      type: Boolean,
      default: false
    },
    isModification: {
      required: true,
      type: Boolean
    },
    justSave: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      sizes: [
        {
          text: this.$t('components.formOpen.fields.isLong[1].name'),
          value: false
        },
        {
          text: this.$t('components.formOpen.fields.isLong[2].name'),
          value: true
        }
      ],
      /**
       * @type {OpenQuestionAir}
       */
      question: {}
    }
  },
  async created () {
    if (this.isModification) {
      await this.loadQuestion({
        questionType,
        id: this.$route.params.id
      })
    } else if (this.isClone) {
      await this.cloneQuestion({
        questionType,
        id: this.$route.params.id
      })
    } else {
      this.initQuestion(questionType)
    }

    this.question = { ...this.questionOpen }
  },
  computed: {
    ...mapGetters('Questions', [
      'questionOpen'
    ]),
    labelErrors () {
      const errors = []
      if (!this.$v.question.$dirty) return errors
      if (!this.$v.question.label.required) errors.push('Le libellé doit être renseigné.')
      if (!this.$v.question.label.maxLength) errors.push('Le libellé doit avoir moins de 50 caractères.')
      return errors
    },
    textErrors () {
      const errors = []
      if (!this.$v.question.$dirty) return errors
      if (!this.$v.question.text.required) errors.push('Le texte de la question doit être renseigné.')
      return errors
    }
  },
  validations: {
    question: {
      label: {
        required,
        maxLength: maxLength(50)
      },
      text: {
        required
      },
      isLong: {
        required
      },
      required: {
        required
      },
      isActive: {
        required
      }
    }
  },
  methods: {
    ...mapActions('Questions', [
      'cloneQuestion',
      'initQuestion',
      'loadQuestion'
    ]),
    save (extraAction = '') {
      this.$v.$touch()
      const saveType = 'save' + extraAction
      if (!this.$v.$invalid) {
        this.$emit('save', {
          question: this.question,
          saveType: saveType
        })
        if (extraAction === 'New') {
          this.$v.$reset()
          this.initQuestion(questionType)
          this.question = { ...this.questionOpen }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppTooltipErnest";

  .v-radio {
    margin-left: 20px;
  }
</style>
